import { Course } from './course';

export class StreamCourse {
    id: number;
    stream_id: number;
    course_id: number;
    course: Course;
    position: number;
    constructor(streamCourse?) {
        if (streamCourse) {
            this.id = streamCourse.id;
            this.stream_id = streamCourse.stream_id;
            this.course_id = streamCourse.course_id;
            this.course = streamCourse.course;
            this.position=streamCourse.position;
        }
    }
}
